@if (filterData$ | async; as filterData) {
    <button mat-icon-button (click)="clear()">
        <mat-icon>close</mat-icon>
    </button>
}
<button mat-icon-button (click)="openSheet()">
    <mat-icon>tune</mat-icon>
</button>
